import '../../components/Header';
import '../../components/PseudoLinks';
import '../../components/LinkAnchors';
import '../../components/Testimonials/Slider';
import { observeElement } from '@uvocore-front/utils';
import tabsInit from '../../components/Tabs';

observeElement({
  element: '[data-tabs]',
  marginValue: 100,
  callback: () => {
    const tabs = document.querySelectorAll('[data-tabs]');
    if (tabs) {
      tabs.forEach(tab => {
        tabsInit({ selector: tab, startPaneIndex: 1 });
      });
    }
  },
});
